export function formatCPF(value) {
  const regex = /(\d{3})(\d{3})(\d{3})(\d{2})/;

  return value.replace(regex, "$1.$2.$3-$4");
}

export function formatCNPJ(value) {
  const regex = /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/;

  return value.replace(regex, "$1.$2.$3/$4-$5");
}



// WEBPACK FOOTER //
// ./src/utils/format-cpfcnpj.js